import * as React from 'react';
import OEITable from './OEITable';
import { doNothing } from './OEIUtils';
import { createKnovioAccountAPI, fetchAllCentralKnovioMappingData, updateKnovioAccountAPI, manageKnovioAccountAPI ,deleteAccountmappings} from './APIService';
import { useEffect } from 'react';
import { EMPTY, LOADING, NO_ACCOUNTS_MAPPED } from './Constants';
export default function OECentralKnovioPage() {
    const [accounts, setAccounts] = React.useState([])
    const [generate, setGenerate] = React.useState('true');
    const [newAccountData, setNewAccountData] = React.useState();
    const [closePopover, setClosePopover] = React.useState(true);
    const [message, setMessage] = React.useState(LOADING);
    const [errors, setErrors] = React.useState({ error1: EMPTY, error2: EMPTY, error3: EMPTY });

    useEffect(function () {
        fetchTableData();
    }, [])
    const fetchTableData = () => {
        fetchAllCentralKnovioMappingData().then(response => {
            response.accounts.length === 0 ? setMessage(NO_ACCOUNTS_MAPPED) : setMessage(EMPTY)
            setAccounts(response.accounts);
        })
    };
    const columns = [
        { id: 'oecAccountName', label: 'Account Name', align: 'left', edit: true, width: '20%', button: false },
        { id: 'oecAccountId', label: 'Account Number', button: false, edit: false, width: '20%' },
        { id: 'knovioAccountId', label: 'Knovio Account', button: false, edit: false, width: '20%' },
        { id: 'Manage', label: EMPTY, buttonLabel: 'Manage', button: true, edit: false, width: '10%', align: 'right' }
    ];
    const getMappings = () => {
        const newArr = accounts.map((element, index) => {
            return { ...element, id: element.oecAccountId, accountName: element.oecAccountName, accountNumber: element.oecAccountId };
        });
        return newArr;
    }
    function validateData(data) {
        var errorList = [];
        if (data.accountName === EMPTY) {
            errorList = { ...errorList, error2: "OE Central Account Name is required" }
        } else if (data.accountName.length > 255) {
            errorList = ({ ...errorList, error2: 'Account Name length should be less than 255 characters' })
        }
        if (data.accountNumber === EMPTY) {
            errorList = { ...errorList, error1: "OE Central Account Number is required" }
        } else if (!/^\d+$/.test(data.accountNumber)) {
            errorList = ({ ...errorList, error1: 'OE Central Account Numbers are made up of numbers only' })
        } else if (data.accountNumber.length > 255) {
            errorList = ({ ...errorList, error1: 'Account Number length should be less than 255 characters' })
        }
        if (data.centralData.length === 0) {
            errorList = ({ ...errorList, error3: 'OE System Mapping is required' })

        }
        setErrors({ ...errorList })
        return errorList.length === 0;
    }
    function createMapping() {
        if (validateData(newAccountData)) {
            createKnovioAccountAPI(newAccountData).then(data => {
                if (data.message === "Account mapping with given system is already exists.") {
                    setErrors({ ...errors, error1: "Account mapping with given Account Number is already exists." });
                    setGenerate(true);
                } else {
                    setNewAccountData({ ...newAccountData });
                    setGenerate(false);
                    setClosePopover(true);
                    fetchTableData();
                }
            });
        }
    }
    function validateEditData(data) {
        var errorList = [];
        if (data.accountName === EMPTY) {
            errorList = { ...errorList, error2: "OE Central Account Name is required" }
        } else if (data.accountName.length > 255) {
            errorList = ({ ...errorList, error2: 'Account Name length should be less than 255 characters' })
        }
        if (data.accountNumber === EMPTY) {
            errorList = { ...errorList, error1: "OE Central Account Number is required" }
        } else if (! /^\d+$/.test(data.accountNumber)) {
            errorList = ({ ...errorList, error1: 'OE Central Account Numbers are made up of numbers only' })
        } else if (data.accountNumber.length > 255) {
            errorList = ({ ...errorList, error1: 'Account Number length should be less than 255 characters' })
        }
        setErrors({ ...errorList })
        return errorList.length === 0;
    }
    const edit = () => {
        if (newAccountData.centralData.length < 1) {
            setErrors({ ...errors, error3: 'OE System Mapping is required' })
        } else if (newAccountData.knovioCreationAccountId !== undefined && newAccountData.knovioCreationAccountId !== newAccountData.knovioAccountId) {
            manageKnovioAccountAPI(JSON.stringify({
                oecAccountId: newAccountData.oecAccountId, knovioAccountId: newAccountData.knovioAccountId,
                newKnovioAccountId: newAccountData.knovioCreationAccountId, accountName: newAccountData.oecAccountName
            })).then(() => {
                setNewAccountData({ ...newAccountData });
                setGenerate(false);
                setClosePopover(true);
                fetchTableData();
            })

        } else
            if (validateEditData(newAccountData)) {
                updateKnovioAccountAPI(newAccountData).then(() => {
                    setNewAccountData({ ...newAccountData });
                    setGenerate(false);
                    setClosePopover(true);
                    fetchTableData();
                })
            }
    }
    const deleteAllAccountMappings = (data) => {
        console.log(data);
        
    deleteAccountmappings(data.id).then(response => {
        setClosePopover(true)
        fetchTableData();
      })
    }
    return (
        <>
            <OEITable removeMainItem={doNothing} delete={deleteAllAccountMappings} headerStyle='sticky-header' tableHeaderStyle='table-header' setSystemName={doNothing}
                edit={edit} closePopover={closePopover} setClosePopover={setClosePopover} errors={errors} setErrors={setErrors}
                onclick={createMapping} columns={columns} setGenerate={setGenerate} generate={generate}
                handleManageAcct={doNothing} tableHeadings='OE Central' setEmail={doNothing}
                setNewData={setNewAccountData} newAction='OEC Account Link' handleClickGenerate={doNothing}
                newData={newAccountData} rowData={getMappings()} message={message} filterField={'oecAccountName'}></OEITable>
        </>
    );
}
